import { Controller } from 'stimulus';
import Animation from 'src/animation';

import sprite1 from 'images/animations/overhight_load/1.png';
import sprite2 from 'images/animations/overhight_load/2.png';
import sprite3 from 'images/animations/overhight_load/3.png';
import sprite4 from 'images/animations/overhight_load/4.png';
import sprite5 from 'images/animations/overhight_load/5.png';

export default class extends Controller {
  connect() {
    const ratio = 1.21;

    const options = {
      canvasWidth: this.element.offsetWidth,
      canvasHeight: this.element.offsetWidth / ratio,
      sources: this.sources,
      steps: this.steps,
      element: this.element
    };

    let rangeEl = this.element.querySelector('input')

    rangeEl.min = 0;
    rangeEl.max = 4;
    rangeEl.step = 1;
    rangeEl.value = 0;

    const animation = new Animation(options);

    let initialSprite = new Image();
    initialSprite.src = sprite1;
    initialSprite.onload = function() {
      animation.render(0)
    }
  }

  get sources() {
    return [
      sprite1,
      sprite2,
      sprite3,
      sprite4,
      sprite5
    ]
  }

  get steps() {
    return [
      "13'6 and below is a legal height on the interstate where you can pass all bridges with no issue.",
      "When you exceed 13'6 tall, most states (but not all) require a permit to guide the truck along, and a front pole escort may be required. ",
      'Even greater heights may require additional route surveys, mandatory front pole car escorts and other requirements that may vary by due to varying safety standards in each state.',
      'At these heights you have to be routed off highways to avoid overpasses, and bucket trucks may be required to lift wires and remove overhead signs and very likely police escorts may be needed.',
      "As the height of the transported load increases some states may deny travel, while others require so many additional reviews that it may take up to a year to obtain a permit. </br> </br> *<small>Note that just because one state approves your exit from that state, doesn't mean another border state will approve your entrance. This is what makes over height loads especially tricky.</small>"
    ]
  }
}
